const NS = 'SiteHeaderBottomMenuWidget';
const CLS = 'siteHeaderBottomMenuWidget';

export class SiteHeaderBottomMenuWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$siteHeaderBottomWidget;
		this.$items = this.$element.find(`.${CLS}-item`);
		this.$toggler = this.$element.find(`.${CLS}-item-toggler`);
		this.$togglerLink = this.$toggler.find(`.${CLS}-item-toggler-link`);
		this.$toggler.on('click', (event) => {
			let $element = $(event.currentTarget);
			let isActive = $element.attr('data-active') === 'true';
			if(!isActive) {
				this.showSubmenu($element);
			}
			else {
				this.hideSubmenu($element);
			}
		});

		this.$element.on(`${CLS}.open`, (_event, params) => {
			this.$siteHeaderBottomWidget = params.siteHeaderBottomWidget;
			this.setDropdownPosition();
			this.setDropdownHeight();
			this.$element.addClass('active');
		});

		this.$element.on(`${CLS}.close`, () => {
			this.$element.removeClass('active');
			let $activeToggler;
			this.$toggler.each((index, element) => {
				let isActive = $(element).attr('data-active') === 'true';
				if(isActive) {
					$activeToggler = $(element);
				}
			});

			if($activeToggler && $activeToggler.length > 0) {
				this.hideSubmenu($activeToggler);
			}
		});

		this.$togglerLink.on('click', (event) => {
			event.stopImmediatePropagation();
		});
	}

	setDropdownPosition() {
		this.$element.css({
			top: this.$siteHeaderBottomWidget.offset().top + this.$siteHeaderBottomWidget.height() + 1
		});
	}

	setDropdownHeight() {
		let $siteHeaderWidget = $('.siteHeaderWidget');
		let $siteHeroWidget = $('.siteHeroWidget');
		let offsetTop = Math.floor($siteHeaderWidget.last().height());
		if($siteHeroWidget.is(':visible')) {
			offsetTop += Math.floor($siteHeroWidget.height());
		}
		this.$element.css({
			maxHeight: `calc(100vh - ${offsetTop}px)`
		});
	}

	hideSubmenu($element) {
		this.$items.show();
		$element.attr('data-active', false);
		$element.next().hide();
		let $siteHeaderBottomSubmenuWidget = $element.next().children('[data-wg="SiteHeaderBottomSubMenuWidget"]');
		$siteHeaderBottomSubmenuWidget.trigger('siteHeaderBottomSubMenuWidget.dropdown.deactivate', {}); // Deactivates all the dropdowns
	}

	showSubmenu($element) {
		let $parent = $element.parent();

		this.$items.hide();
		$parent.show();
		$element.attr('data-active', true);
		$element.next().show();
	}
}
